import z from "zod";
const localized = (code, issue) => {
    const params = "params" in issue ? issue.params : undefined;
    const out = z.config().customError?.({ ...issue, params: { ...params, code } });
    return typeof out === "string" ? out : (out?.message ?? undefined);
};
export const issueMessage = (code, message) => ({
    error: (issue) => localized(code, issue) ?? message,
});
export const customIssue = (code, message, issue) => {
    const raw = {
        code: "custom",
        input: undefined,
        path: issue.path,
        params: { ...issue.params, code },
    };
    return { ...raw, message: localized(code, raw) ?? message };
};
//# sourceMappingURL=issue-message.js.map